<template>
  <transition name="fade">
    <div
      v-show="true"
      ref="modal-root"
      class="tm"
    >
      <div class="modal-container">
        <div
          ref="modal-content"
          class="modal"
        >
          <topic
            :modal="true"
            :subtopic="subtopic"
            :topic="topic"
            @accordion-toggled="$emit('accordion-toggled', $event)"
            @topic-modal-back-clicked="$emit('topic-modal-back-clicked', $event)"
            @nested-subtopic-selected="$emit('nested-subtopic-selected', $event)"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Topic from '@components/topics/topic';

export default {
  components: { Topic },
  props: {
    subtopic: {
      type: Object,
    },
    topic: {
      type: Object,
    },
    modalIdx: {
      type: Number,
    },
    numOfModals: {
      type: Number,
    },
  },
  emits: ['accordion-toggled', 'topic-modal-back-clicked', 'nested-subtopic-selected'],
  watch: {
    modalIdx: {
      handler(val) {
        this.handleZIndex(val);
      },
    },
  },
  mounted() {
    this.handleZIndex(this.modalIdx);
  },
  methods: {
    handleZIndex(val) {
      const el = this.$refs['modal-root'];
      el.style['z-index'] = (50 + this.numOfModals) - val;

      const elContent = this.$refs['modal-content'];
      elContent.style.marginTop = (-24 * this.modalIdx) + 'px';
      elContent.style.width = (95 - (3 * this.modalIdx)) + '%';

    },
  },

};
</script>

<style lang="scss" scoped>

.tm {
  position: fixed;
  top: rem-calc(48);
  left: rem-calc(220);
  right: 0;
  bottom: rem-calc(64);
  transition: all 300ms linear;

  @include breakpoint(small) {
    left: 0;
    top: rem-calc(72);
  }
  .modal-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255,255,255,0.85);
    .modal {
      overflow-y: scroll;
      height: 90%;
      width: 95%;
      background-color: white;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.22);
      border-top: 2px #00d0dc solid;
      transition: all 300ms linear;
    }
  }
}
</style>
